<!-- (c) 津职模拟考 -->
<template>
  <div id="content" class="container">
    <div class="filter-box">
      <div class="select" @click="showPicker()">
        <img class="icon" src="../../assets/img/select.png" />
        <div class="label">筛选：</div>
        <div class="value">{{ cid1_word }} {{ cid2_word }}</div>
      </div>
    </div>
    <template v-if="loading && list.length == 0">
      <skeletonPaper></skeletonPaper>
    </template>
    <template v-else-if="list.length > 0">
      <div class="paper">
        <div
          class="topic-item"
          :data-id="item.id"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item.id)"
        >
          <div class="vod-course-item-comp">
            <div class="vod-course-thumb">
              <img :src="item.coverUri" />
            </div>
            <div class="vod-course-body">
              <div class="vod-course-title">
                {{ item.title }}
              </div>
              <div class="vod-course-info">
                <div class="vod-course-sub">{{ item.categoryName }}</div>
                <div class="lock" v-if="!item.userCanJoin">
                  <img class="" src="../../assets/img/course-lock.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="list.length == 0">
      <div class="none">
        <none></none>
      </div>
    </template>
    <div class="picker" v-if="show_picker">
      <van-popup v-model="show_picker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="onCancel"
          @confirm="onConfirm"
          @change="onChange"
        />
      </van-popup>
    </div>
    <nav-footer type="course"></nav-footer>
  </div>
</template>
<script>
import Vue from "vue";
import { Picker } from "vant-green";
import { Popup } from "vant-green";
Vue.use(Popup);
Vue.use(Picker);

import SkeletonPaper from "../../components/skeleton/skeletonPaper";
import None from "../../components/none.vue";
import NavFooter from "../../components/footer.vue";

export default {
  components: {
    SkeletonPaper,
    None,
    NavFooter,
  },
  data() {
    return {
      header_title: "课程",
      cid1_word: "全部",
      cid2_word: "",
      show_picker: false,
      columns: "",
      pagination: {
        page: 1,
        size: 10,
        cid1: this.$route.query.cid || 0,
        cid2: this.$route.query.child || 0,
      },
      over: false,
      loading: false,
      categoriesData: "",
      resCategoriesData: "",
      list: [],
      vid1: 0,
      vid2: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (from.meta.keepAlive) {
      // 只针对 keep-alive 的页面记录滚动位置
      let $content = document.querySelector("#content"); // 列表的外层容器
      let scrollTop = $content ? $content.scrollTop : 0;
      from.meta.scrollTop = scrollTop;
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "CourseDetail") {
      to.meta.useCache = true;
    } else {
      to.meta.useCache = false;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.useCache) {
      window.addEventListener("scroll", this.ScrollToBottomEvt, true);
      Object.assign(this.$data, this.$options.data.call(this));
      this.getCategoryList();
      this.getData();
    } else {
      window.addEventListener("scroll", this.ScrollToBottomEvt, true);
    }
    let scrollTop = this.$route.meta.scrollTop;
    if (scrollTop && scrollTop !== 0) {
      // 初次进入页面不执行，返回页面执行
      let $content = document.querySelector("#content");
      if ($content) {
        this.$nextTick(() => {
          $content.scrollTop = scrollTop;
        });
      }
    }
  },
  deactivated() {
    window.removeEventListener("scroll", this.ScrollToBottomEvt, true);
  },
  methods: {
    onChange(picker, values) {
      picker.setColumnValues(1, this.categoriesData[values[0]]);
    },
    onCancel() {
      this.show_picker = false;
    },
    onConfirm(picker, values) {
      console.log(this.resCategoriesData);
      console.log(values);
      this.vid1 = values[0];
      this.vid2 = values[1];
      this.pagination.cid1 = this.resCategoriesData[values[0]].id || 0;
      this.pagination.cid2 = this.resCategoriesData[values[0]].children[
        values[1]
      ]
        ? this.resCategoriesData[values[0]].children[values[1]].id
        : 0;
      this.show_picker = false;
      this.resetData();
      this.getData();
      this.cid1_word = this.resCategoriesData[values[0]].name;
      this.cid2_word = this.resCategoriesData[values[0]].children[values[1]]
        ? " - " + this.resCategoriesData[values[0]].children[values[1]].name
        : "";
    },
    showPicker() {
      this.show_picker = true;
      if (this.pagination.cid1) {
        this.columns[0].defaultIndex = this.vid1;
        let name = this.resCategoriesData[this.vid1].name;
        console.log(name);
        this.columns[1].values = this.categoriesData[name];
      }
      if (this.pagination.cid2) {
        this.columns[1].defaultIndex = this.vid2;
      }
    },
    ScrollToBottomEvt() {
      const el = document.getElementById("content");
      const toBottom = el.scrollHeight - window.screen.height - el.scrollTop;
      if (toBottom < 10) {
        this.getData(true);
      }
    },
    resetData() {
      this.list = [];
      this.pagination.page = 1;
      this.over = false;
    },
    getCategoryList() {
      this.$api.Course.categoryList().then((res) => {
        let all = { id: 0, name: "全部", children: [] };
        res.data.unshift(all);
        console.log(res.data);
        this.resCategoriesData = res.data;
        this.loading = false;
        let categoriesData = {};
        let i = 0;
        let first = "";
        res.data.forEach((item) => {
          item.children.unshift(all);
          if (i == 0) {
            first = item.name;
          }
          categoriesData[item.name] = [];
          i++;
          item.children.forEach((cate) => {
            categoriesData[item.name].push(cate.name);
          });
        });
        this.categoriesData = categoriesData;
        console.log(categoriesData);
        this.columns = [
          {
            values: Object.keys(categoriesData),
            className: "cid1",
          },
          {
            values: categoriesData[first],
            className: "cid2",
          },
        ];
      });
    },
    getData(more = false) {
      if (this.over) {
        return;
      }
      if (this.loading) {
        return;
      }
      if (more) {
        this.pagination.page++;
      }
      this.loading = true;
      console.log(this.pagination);
      this.$api.Course.courseList(this.pagination).then((res) => {
        let list = res.data.records;
        if (list.length > 0) {
          this.list.push(...list);
        }
        setTimeout(() => {
          this.loading = false;
          if (list.length < this.pagination.size) {
            this.over = true;
          }
        }, 200);
      });
    },
    goDetail(id) {
      console.log(id);
      this.$router.push({ name: "CourseDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.filter-box {
  width: 100%;
  height: auto;
  float: left;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  line-height: 30px;
  padding: 16px 16px;
  position: fixed;
  z-index: 999;
  .select {
    flex: 1;
    height: auto;
    position: relative;
    font-size: 15px;
    font-weight: 400;
    display: flex;
    align-items: center;
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
}
.picker {
  width: 100%;
  position: fixed;
  bottom: 0;
}
.paper {
  padding: 0 16px;
  margin-top: 60px;
  margin-bottom: 60px;
}
.topic-item {
  width: 100%;
  display: flex;
  padding: 15px;
  box-sizing: border-box;
}

.vod-course-item-comp {
  width: 100%;
  height: auto;
  float: left;
  display: flex;
}

.vod-course-thumb {
  width: 120px;
  height: 90px;
  margin-right: 10px;
}

.vod-course-thumb img {
  width: 120px;
  height: 90px;
  border-radius: 4px;
}

.vod-course-body {
  flex: 1;
  padding-top: 5px;
}

.vod-course-title {
  width: 100%;
  height: 40px;
  float: left;
  font-size: 15px;
  font-weight: 500;
  color: #171923;
  line-height: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 15px;
}

.vod-course-info {
  width: 100%;
  height: auto;
  float: left;
  display: flex;
  align-items: center;
  position: relative;
}
.lock {
  position: absolute;
  right: 16px;
  width: 16px;
  height: 16px;
}

.lock img {
  width: 16px;
  height: 16px;
  border-radius: 0px;
  overflow: visible;
  opacity: 1;
  transition: opacity 0.5s ease-in-out 0s;
  background-color: transparent;
}

.vod-course-sub {
  flex: 1;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 12px;
}
</style>
